<div [formGroup]="form" dir="rtl" class="mb-2">
  <label *ngIf="question.controlType !== 'checkbox'" class="dynamic-lable" [attr.for]="question.key">{{ question.label
    }}</label>
  <div [ngSwitch]="question.controlType">
    <!-- Disabled -->
    <span *ngSwitchCase="'disabled'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <input class="ms-input-view" id="disabled-input" type="text" [formControlName]="question.key" pInputText
        [id]="question.key" [type]="question.type" [value]="question.value" hidden />
      {{ question.valueShow ? question.valueShow : question.value }}
    </span>
    <!-- Password -->
    <span *ngSwitchCase="'password'">
      <input class="ms-input-view" id="password" type="password" pInputText [disabled]="false" [id]="question.key"
        [type]="question.type" [value]="question.value?.trim()" (blur)="question.value = question.value?.trim()" />
    </span>
    <!-- Text Box -->
    <span *ngSwitchCase="'textbox'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <input class="ms-input-view 1111 w-100" [ngStyle]="{
          'pointer-events': question.disable ? 'none' : 'auto',
          'background-color': question.disable ? '#f2f2f2' : ''
        }" pInputText [formControlName]="question.key" [id]="question.key" [type]="question.type"
        [value]="question.value" />
    </span>
    <!-- Text Editor -->
    <span *ngSwitchCase="'texteditor'" class="p-input-icon-right w-100">
      <p-editor plainTextPaste class="question-p-editor w-100" [style]="{ height: '320px' }" [ngStyle]="{
          'pointer-events': question.disable ? 'none' : 'auto',
          'background-color': question.disable ? '#f2f2f2' : ''
        }" [formControlName]="question.key" [id]="question.key" />
    </span>
    <!-- Number  -->
    <span *ngSwitchCase="'number'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <input pInputText [formControlName]="question.key" class="ms-input-view w-100" [id]="question.key"
        [type]="question.type" [value]="question.value" />
    </span>
    <!-- DropDown -->
    <span *ngSwitchCase="'dropdown'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <p-dropdown appendTo="body" [id]="question.key" [options]="question.options" [required]="question.required"
        [filter]="question.filter" [formControlName]="question.key" [placeholder]="'حدد ' + question.label"
        styleClass=" sstarabic w-100">
        <ng-template let-item pTemplate="item">
          <i [ngClass]="item.icon"></i>
          {{ item.label }}
        </ng-template>
      </p-dropdown>
    </span>

    <!-- DropDown Checkbox -->
    <span *ngSwitchCase="'dropdowncheckbox'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <p-multiSelect
        [id]="question.key"
        [options]="question.options"
        [required]="question.required"
        [filter]="question.filter"
        [formControlName]="question.key"
        [placeholder]="'حدد ' + question.label"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        [panelStyleClass]="'always-down-'+question.key"
        styleClass="sstarabic w-100"
        (onShow)="ensureMultiSelectOpenDown(question.key)">
        <ng-template let-item pTemplate="item">
          <i *ngIf="item.icon" [ngClass]="item.icon"></i>
          {{ item.label }}
        </ng-template>
      </p-multiSelect>
    </span>

    <!-- IconBox -->
    <span *ngSwitchCase="'iconbox'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>

      <p-dropdown appendTo="body" [id]="question.key" [options]="iconOptions" [required]="question.required"
        [formControlName]="question.key" [placeholder]="'حدد ' + question.label" [filter]="true"
        styleClass=" sstarabic w-100 iconbox-flex" class="custom-dropdown" [panelStyleClass]="'custom-icons-overlay'">

        <ng-template pTemplate="filter" let-options="options">
          <div class="flex gap-1">
            <div class="p-inputgroup" (click)="$event.stopPropagation()">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input type="text" pInputText placeholder="{{ 'search' | translator}}"
                (keyup)="customFilterFunction($event)" />
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="selectedItem">
          <div class="d-flex align-items-center gap-2" *ngIf="form.get(question.key)?.value">
            <span [ngClass]="form.get(question.key)?.value"></span>
            <span>{{ form.get(question.key)?.value }}</span>

          </div>
        </ng-template>

        <ng-template let-option pTemplate="item">
          <span [ngClass]="option.value"></span>
        </ng-template>
      </p-dropdown>
    </span>
    <!-- Tree Select -->
    <span *ngSwitchCase="'treeselect'" class="p-input-icon-right w-100">
      <i [class]="question.icon"></i>
      <p-treeSelect class="w-md-20rem w-100" [selectionMode]="question.selectionMode" [metaKeySelection]="false"
        appendTo="body" containerStyleClass="w-100" [formControlName]="question.key" [options]="question.treeOptions"
        [placeholder]="'حدد ' + question.label" [filter]="question.filter" [filterInputAutoFocus]="true">
        <ng-template let-node pTemplate="default">
          <div class="d-flex">
            <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
              class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-treeSelect>
    </span>
    <!-- Multi Select -->
    <span *ngSwitchCase="'mutiselect'" class="p-input-icon-right w-100">
      <p-multiSelect
        class="v4-multi"
        [id]="question.key"
        [options]="question.options"
        [required]="question.required"
        [formControlName]="question.key"
        optionLabel="name"
        appendTo="body"
        [panelStyleClass]="'always-down-'+question.key"
        (onShow)="ensureMultiSelectOpenDown(question.key)">
      </p-multiSelect>
    </span>
    <span *ngSwitchCase="'imageUpload'" class="p-input-icon-right w-100">
      <input class="form-control ms-input-view" type="file" id="formFile" (input)="onChange($event)" accept="image/*" />
      <p class="text-muted">{{ question.help }}</p>

      <img style="display: block; background: white; width: 80px; height: 80px; padding:5px;" class="rounded-3 mb-1"
        *ngIf="!!imageBase64" src="{{ imageBase64 }}" alt="image" />
    </span>
    <span *ngSwitchCase="'file'" class="p-input-icon-right w-100">
      <input [disabled]="!enabled" class="form-control ms-input-view" type="file" id="formFile"
        (input)="onFileChange($event)" accept="*/*" />
      <p class="text-muted">{{ question.help }}</p>

      <div class="d-flex" *ngFor="let link of question.fileLinks">
        <div class="d-flex bg-highlight justify-content-center align-items-center p-1 rounded-3 mb-1">
          <span class="ml-2 mb-1">{{ link.name }}</span>
          <i (click)="deleteLinkRequest(link)" role="button" class="pi pi-times mx-2"></i>
        </div>
      </div>
    </span>

    <!-- radio Button  -->
    <span *ngSwitchCase="'radiobutton'">
      <div *ngFor="let option of question.options" class="flex flex-wrap gap-3">
        <div class="flex align-items-center">
          <p-radioButton [name]="question.key" [value]="option.value" [formControlName]="question.key"
            [inputId]="option.label!" (onClick)="onImgTypeChange(option.value)"></p-radioButton>
          <label [for]="question.key" class="mx-2 color-grey">{{ option.label }}</label>
        </div>
      </div>
    </span>
    <!-- Check Box  -->

    <span *ngSwitchCase="'checkbox'" class="d-flex align-items-center gap-2">
      <p-checkbox [formControlName]="question.key" [binary]="true" (onChange)="checkBoxChanged($event)"
        [inputId]="question.key"></p-checkbox>
      <label [for]="question.key" class="checkbox-inline-label mb-0 color-grey" style="cursor: pointer;">{{ question.label }}</label>
    </span>
    <!-- Text Area  -->
    <span *ngSwitchCase="'textarea'">
      <textarea class="textarea-ui"
         [id]="question.key" rows="5" cols="30" pInputTextarea [required]="question.required"
        [formControlName]="question.key"></textarea>
    </span>
    <!-- Time Picker -->
    <span dir="ltr" *ngSwitchCase="'timepicker'">
      <p-calendar class="ppp-calander cvcvcv" [showIcon]="true" [showTime]="question.showTime" [minDate]="minDate"
        [styleClass]="question.className" [required]="question.required" [formControlName]="question.key"
        [dateFormat]="question.format || 'dd-mm-yy'" appendTo="body" [touchUI]="question.touchUI || false"></p-calendar>
    </span>
   <!-- functionLink -->
    <span *ngSwitchCase="'functionLink'">
      <p-button [label]="question.label" [icon]="question.icon" (onClick)="question.function ? question.function() : null"
        class="p-button-sm p-button-secondary"></p-button>
    </span>
  </div>
  <div class="errorMessage text-danger" *ngIf="
      form.controls[question.key].invalid &&
      (form.controls[question.key].dirty || form.controls[question.key].touched)
    ">
    '{{ "Data is required" | translator }}'
  </div>
</div>